import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { PublicService } from 'src/app/servicios/public/public.service';

@Component({
  selector: 'app-detalle-tramite-c',
  templateUrl: './detalle-tramite-c.component.html',
  styleUrls: ['./detalle-tramite-c.component.css']
})
export class DetalleTramiteCComponent implements OnInit {
  public tramite: any = [];
  public id : any;

  constructor( private servi: PublicService, public route: ActivatedRoute) { 
    this.route.params.subscribe(param => {this.id = param['id']});

    this.servi.getDetalleTramite(this.id).subscribe(data=>{
      if (data['success']) {
          
        this.tramite = data['formTipoTramite'];        
      } 
      else {
        Swal.fire({ type: 'warning', title: 'No existe ese trámite', showConfirmButton: false, timer: 1500 });
      }      
    });
  }
 
  ngOnInit() {
  }

}
